import { s3 } from '@/plugins/axios'
import Service from '@/services/service'
import axios from 'axios'

/**
 * @type {S3Filesystem}
 */
export default class S3Filesystem extends Service {
    /**
     * @param {Object} options
     */
    constructor (options = {}) {
        super(options)
        this.http = s3
        this.resource = 'cloud_system_resources'
    }

    /**
     * Busca o arquivo que contém a lista de instâncias que devem ser
     * ignoradas pelo Hotjar e Wootric
     * 
     * @returns JSON
     */
    getCompaniesRestricted() {
        return this.http.get(this.constructor.normalize(this.resource, 'companies_restricted.json'))
    }

    /**
     * Busca o arquivo que contém a lista de novidades a serem mostradas no
     * menu header
     * 
     * @returns JSON
     */
    getNewsMenu() {
        return this.http.get(
            this.constructor.normalize(this.resource, 'news-menu.json'),
            {
                params: {
                    v: Math.random()
                }
            }
        )
    }

    /**
     * Busca o arquivo que contém a lista de novidades a serem mostradas no
     * modal de mensagens
     * 
     * @returns JSON
     */
    getNewsModal() {
        return this.http.get(
            this.constructor.normalize(this.resource, 'news-modal.json'),
            {
                params: {
                    v: Math.random()
                }
            }
        )
    }

    /**
     * Busca o arquivo que contém a lista de relatórios Athena
     * 
     * @returns JSON
     */
    getAthenaReports() {
        return this.http.get(this.constructor.normalize('reports', 'reportsAthena.json'))
    }

    /**
     * Busca o arquivo com os tipos de integração a serem cadastradas
     *
     * @returns JSON
     */
    getIntegrationTypes() {
        return this.http.get(this.constructor.normalize(this.resource, 'integrations.json'))
    }

    /**
     * Busca o arquivo com os campos Facilita para o mapeamento dos campos das unidades
     *
     * @returns JSON
     */
    getFacilitaUnitFields() {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(this.resource, 'fields_mapping'),
                '/fields-facilita.json'
            )
        )
    }

    /**
     * Recebe o tipo de uma integração e busca o arquivo com os campos para o mapeamento
     * dos campos das unidades
     *
     * @param {String} integration Tipo da integração selecionada
     * @returns JSON
     */
    getERPUnitFields(integration) {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(this.resource, 'fields_mapping'),
                `fields-${integration}.json`
            )
        )
    }

    /**
     * Busca o arquivo contendo os modelos de exibição (regex) para o mapeamento dos
     * campos das unidades
     */
    getUnitExibitionModels() {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(this.resource, 'fields_mapping'),
                'regexp-patterns.json'
            )
        )
    }

    /**
     * Busca os contextos e tipos de contexto dos campos a serem mapeados no sistema
     *
     * @returns JSON
     */
    getContextFields() {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(this.resource, 'fields_mapping'),
                'fields_context_mapping.json'
            )
        )
    }

    getERPFieldsS3() {
        return axios.get('https://gs-directory-files-production.s3.amazonaws.com/cloud_system_resources/erp-fields.json')
    }

    getProposalType() {
        return axios.get('https://gs-directory-files-production.s3.amazonaws.com/cloud_system_resources/proposal-data-type.json')
    }

     /**
     * Busca os contextos e tipos de contexto dos campos a serem mapeados no sistema
     *
     * @returns JSON
     */
    getAdvancedConfigs() {
        return this.http.get(
            //todo adicionar timestamp para evitar cache na requisicao
            this.constructor.normalize(this.resource, `configuracoes_avancadas.json?t=${new Date().getTime()}`)
        )
    }

    /**
     * @param {String} start
     * @param {String} end
     * @returns {String}
     */
    static normalize (start, end) {
        return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1')
    }
}